module.exports = __webpack_public_path__ + "static/media/BeneficiosComerciales.35ddd79c.jpg";